var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfocircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3359 9.00065C17.3359 13.5998 13.6026 17.334 9.0026 17.334C4.39427 17.334 0.669272 13.5998 0.669272 9.00065C0.669273 4.39982 4.39427 0.667315 9.00261 0.667316C13.6026 0.667316 17.3359 4.39982 17.3359 9.00065ZM9.73594 12.159C9.73594 12.5582 9.4026 12.8923 9.0026 12.8923C8.6026 12.8923 8.2776 12.5582 8.2776 12.159L8.2776 8.47565C8.2776 8.07482 8.6026 7.75065 9.00261 7.75065C9.40261 7.75065 9.73594 8.07482 9.73594 8.47565L9.73594 12.159ZM8.99427 5.09982C9.40261 5.09982 9.7276 5.43315 9.7276 5.83315C9.7276 6.23315 9.40261 6.55815 9.00261 6.55815C8.59427 6.55815 8.26927 6.23315 8.26927 5.83315C8.26927 5.43315 8.59427 5.09982 8.99427 5.09982Z",
    fill: "#FEB111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfocircle);
export default __webpack_public_path__ + "static/media/infocircle.ade46e63631c4c6d8a544e5c491bea09.svg";
export { ForwardRef as ReactComponent };